import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';

import {
  FilterWithPlaceholderAndFullTextFilterMethod,
  EntitiesListWithViewModesCard,
  Tags,
} from '../index';
import {ACCESS_RIGHTS} from '../../constants';

const rightAvailabilityMap = {
  buttonCreate: [ACCESS_RIGHTS.POLICY_CREATE],
};

class PolicyTable extends Component {
  constructor(props) {
    super(props);

    this.tagsCellRenderer = (row) => (
      <Tags tags={row.value} />
    );

    this.headersFullWidthMode = [];
    this.headersCompressedMode = [];
    this.headersFullWidthMode.push(
      {
        Header: I18n.t('policyPage.policyName'),
        accessor: 'name',
        ...this.getFilter(),
        sortable: false,
        maxWidth: 300,
      },
      {
        Header: I18n.t('policyPage.policyDescription'),
        accessor: 'description',
        sortable: false,
        filterable: false,
        maxWidth: 300,
      },
      {
        Header: I18n.t('policyPage.policyTags'),
        accessor: 'tags',
        Cell: this.tagsCellRenderer,
        sortable: false,
        filterable: false,
      },
    );
    this.headersCompressedMode.push({
      Header: null,
      accessor: 'name',
      ...this.getFilter(),
      sortable: false,
    });
  }

  getFilter = () => (
    FilterWithPlaceholderAndFullTextFilterMethod(
      I18n.t('policyPage.policyNameFilterPlaceholder'),
      ['name'],
    )
  );

  render() {
    const {
      handleClickButtonNew,
      handleClickCampusRow,
      mode,
      isEditMode,
      selectedPolicyIndex,
      tableData,
    } = this.props;

    return (
      <EntitiesListWithViewModesCard
        mode={mode}
        headersFullWidthMode={this.headersFullWidthMode}
        headersCompressedMode={this.headersCompressedMode}
        tableData={tableData}
        disabled={isEditMode}
        title={I18n.t('policyPage.policyTableTitle')}
        entityType={I18n.t('entitiesTypes.policy')}
        selectedEntityIndex={selectedPolicyIndex}
        handleClickButtonNew={handleClickButtonNew}
        handleClickRow={handleClickCampusRow}
        accessRights={rightAvailabilityMap}
      />
    );
  }
}

PolicyTable.propTypes = {
  handleClickButtonNew: PropTypes.func.isRequired,
  handleClickCampusRow: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool.isRequired,
  mode: PropTypes.string.isRequired,
  selectedPolicyIndex: PropTypes.number.isRequired,
  tableData: PropTypes.array,
};

PolicyTable.defaultProps = {
  tableData: [],
};

export default PolicyTable;
